import { Config, Auth } from "olympe";
import { getLogger } from '@olympeio/core';
import BCP from '../section_bcp/DM_BCP.js';
import { getApplicationContext } from "./Context.js";

/* common utils */
export const EnvironmentMap = {
  dev: "https://ensuring-supply-codev.olympe.io/#app=RC;tab=3",
  preprod: "https://ensuring-supply-preprod.olympe.io/#app=RC;tab=3",
  prod: "https://ensuring-supply.olympe.io/#app=RC;tab=3",
};

/** This will enable to sleep for mentioned seconds*/
export function sleep(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

export async function getCurrentVendorSite(bcp, $) {
  const logger = getLogger('BCPQAEmailTemplate')
  const body = { offset: '0', limit: '100', plants: [bcp.get(BCP.plantIdProp)], materials: [bcp.get(BCP.materialIdProp)] };
  // Run fetch
  let concatenatedString = '';
  let response = await callProxyFromBackend(body, $);
  logger.info(`API Response: ${response}`);
  // API error
  console.log("getCurrentVendorSite: Api Response", response)
  if (response.statusCode === 500) {
      logger.error(`API Error: ${response.statusCode} - ${response.message}`);
      return "";
  } else {
      let uniqueVendorList = uniqueListByProperty(response.materials)?.slice(0, 2)
      for (var i = 0; i < uniqueVendorList.length; i++) {
          const item = uniqueVendorList[i];
          concatenatedString += item.vendorSiteNumber + "-" + item.vendorSiteDescription + "\n"
          logger.info(concatenatedString, "Concatenated vendor site String")
      }
      console.log("::Before returning from return CurrentVendor Site::", concatenatedString)
      return concatenatedString;
  }
}


/**
 * @param {string} payload
 * @return {!Promise<!Object>}
 */
export async function callProxy(payload) {
  const proxyUrl = Config.getParameter('http_proxy_path');
  const rootUrl = Config.getParameter('risk_crisis_path');
  console.log("callProxy - CommonUtil: proxyUrl, rootUrl**", proxyUrl, rootUrl);

  let access_token;

  if (typeof sessionStorage !== "undefined") {
      access_token = sessionStorage.getItem("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM SessionStorage ---", access_token);
  }

  if (!access_token) {
      const applicationContext = getApplicationContext($);
      access_token = applicationContext.get("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM Application Context ---", access_token);
  }

  try {
      // Run request
      const response = await fetch(proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              destination: rootUrl,
              token: Auth.getUserToken().nonce,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
              },
              opperation: 'POST',
              payload: payload
          }),
      });

      // Convert to json
      const responseObject = await response.json();

      // Handle API error
      return responseObject.statusCode === 500
          ? { statusCode: 1, message: responseObject.message }
          : responseObject;
  }
      // Catch error where httpProxy did not respond
  catch (error) {
      return {
          statusCode: 1,
          message: error.message,
      }
  }
}

export async function callProxyFromBackend(payload, $) {
  const proxyUrl = Config.getParameter('http_proxy_path');
  const rootUrl = Config.getParameter('risk_crisis_path');
  console.log("callProxyFromBackend - CommonUtil: proxyUrl, rootUrl**", proxyUrl, rootUrl);

  let access_token;

  if (typeof sessionStorage !== "undefined") {
      access_token = sessionStorage.getItem("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM SessionStorage ---", access_token);
  }

  if (!access_token) {
      const applicationContext = getApplicationContext($);
      access_token = applicationContext.get("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM Application Context ---", access_token);
  }

  try {
      // Run request
      const response = await fetch(proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              destination: rootUrl,
              token: Auth.getUserToken().nonce,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
              },
              opperation: 'POST',
              payload: payload
          }),
      });

      // Convert to json
      const responseObject = await response.json();

      // Handle API error
      return responseObject.statusCode === 500
          ? { statusCode: 1, message: responseObject.message }
          : responseObject;
  }
      // Catch error where httpProxy did not respond
  catch (error) {
      return {
          statusCode: 1,
          message: error.message,
      }
  }
}

// TODO: make the requests with DRAW bricks ! Here I follow the existing pattern of coded API calls
/**
 * @param {string} payload
 * @return {!Promise<!Object>}
 */
export async function callProxyFunction(payload, $) {
  const proxyUrl = Config.getParameter('http_proxy_path');
  const rootUrl = Config.getParameter('risk_crisis_path');
  console.log("callProxyFunction - Inside CommonUtils ::proxyUrl, rootUrl", proxyUrl, rootUrl);

  let access_token;

  if (typeof sessionStorage !== "undefined") {
      access_token = sessionStorage.getItem("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM SessionStorage ---", access_token);
  }

  if (!access_token) {
      const applicationContext = getApplicationContext($);
      access_token = applicationContext.get("ms_auth_token");
      console.log("MS ACCESS TOKEN FROM Application Context ---", access_token);
  }

  try {
      // Run request
      const response = await fetch(proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              destination: rootUrl,
              token: Auth.getUserToken().nonce,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
              },              
              opperation: 'POST',
              payload: payload
          })
      });

      // Convert to json
      //console.log(":: CommonUtils:response ::", response)
      const responseObject = await response.json();
      //console.log(":: CommonUtils ::", responseObject)
      // Handle API error
      return responseObject.statusCode === 500
          ? { statusCode: 1, message: responseObject.message }
          : responseObject;
  }
      // Catch error where httpProxy did not respond
  catch (error) {
      return {
          statusCode: 1,
          message: error.message,
      }
  }
}

export function uniqueListByProperty(list) {
  return Array.from(new Map(list.map((item) => [item["vendorSiteNumber"], item])).values());
}

// validation for input Saving estimate for PM state manadatory feilds 
export const editInputEstimatefield = (alternativeVSCode, mainVendorLinkedAltVendor, anyCostSaving, ghdReduction,
  inputEstimateEdit, vendorName, vendorAddress, vendorCountry,
  vendorCity, vendorContactNumber, vendorEmail) => {
  // checking all mandatory fields
  let isVendorDataFilledIn = [vendorName, vendorAddress, vendorCountry, vendorCity, vendorContactNumber, vendorEmail].every(e => e?.length > 0)
  if (((alternativeVSCode?.length > 0 && mainVendorLinkedAltVendor?.length > 0) || isVendorDataFilledIn)
    && anyCostSaving?.length > 0
    && ghdReduction?.length > 0) {
    // checking if cost saving is yes the inpust saving estimate value should not be 0/empty or null 
    if (anyCostSaving === 'yes') {
      return Number(inputEstimateEdit) > 0;
    } else if (anyCostSaving === 'no') {
      return true;
    }
    return true;
  }
  return false;
}

// Dedicated for notification templating only
export const returnCurrentVendorSite = async (bcp, $) => {
  const logger = getLogger('BCPQAEmailTemplate')
  const body = { offset: '0', limit: '100', plants: [bcp.get(BCP.plantIdProp)], materials: [bcp.get(BCP.materialIdProp)] };
  // Run fetch
  let concatenatedString = '';
  callProxyFromBackend(body, $).then((response) => {
    // API error
    console.log("CommonUtil: returnCurrentVendorSite: Api Response", response)
    if (response.statusCode === 500) {
      logger.error(`API Error: ${response.statusCode} - ${response.message}`);
      return "";
    } else {
      let uniqueVendorList = uniqueListByProperty(response.materials)?.slice(0, 2)
      for (var i = 0; i < uniqueVendorList.length; i++) {
        const item = uniqueVendorList[i];
        concatenatedString += item.vendorSiteNumber + " : " + item.vendorSiteDescription + "\n"
        logger.info(concatenatedString, "Concatenated vendor site String")
      }
    }
    console.log("::Before returning from return CurrentVendor Site::", concatenatedString)    
  }).catch((error) => console.error(`Error while fetching Main vendor/ vendor site: ${error}`));
  return concatenatedString;
}
